import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, StethoscopeIcon, LeafIcon } from 'lucide-react';
const trustItems = [{
  icon: UsersIcon,
  text: '100.000+ zufriedene Kunden'
}, {
  icon: StethoscopeIcon,
  text: 'Von Tierärzten empfohlen'
}, {
  icon: LeafIcon,
  text: 'Natürlich & schonend'
}];
export function TrustBar() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="w-full py-8 border-y" style={{
    backgroundColor: 'var(--color-cream-dark)',
    borderColor: 'var(--color-border)'
  }} data-id="element-147">
      <div className="max-w-3xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-148">
        {trustItems.map(item => <div key={item.text} className="flex items-center gap-3" data-id="element-149">
            <item.icon className="w-5 h-5 flex-shrink-0" style={{
          color: 'var(--color-green)'
        }} data-id="element-150" />
            <span className="text-sm font-medium" style={{
          color: 'var(--color-text)'
        }} data-id="element-151">
              {item.text}
            </span>
          </div>)}
      </div>
    </motion.section>;
}